var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from '@emotion/styled';
import { display, space, themeGet } from 'styled-system';
import { size as createSize } from 'polished';
import Icon from './Icon';
var SpinnerWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), display, space);
SpinnerWrapper.defaultProps = { display: 'flex' };
var SpinnerIcon = styled(Icon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  stroke: ", ";\n"], ["\n  ", ";\n  stroke: ", ";\n"])), function (_a) {
    var size = _a.size;
    return createSize(size);
}, function (_a) {
    var strokeColor = _a.strokeColor;
    return themeGet("colors." + strokeColor);
});
var Spinner = function (_a) {
    var size = _a.size, strokeColor = _a.strokeColor, margin = _a.margin, className = _a.className;
    return (React.createElement(SpinnerWrapper, { className: className, "data-testid": "spinner", role: "progressbar", margin: margin },
        React.createElement(SpinnerIcon, { name: "spinner", size: size, strokeColor: strokeColor })));
};
export default Spinner;
var templateObject_1, templateObject_2;
